type defaultDates = 'startDate' | 'dueDate' | 'dateCombo';
type defaultTitles =
  | 'assignee'
  | 'verifiers'
  | 'followers'
  | 'taskPublisher'
  | 'subTaskPublisher'
  | 'dateCombo';

const getDefaultAssignmentTitle: { [key in defaultTitles]: string } = {
  assignee: 'انجام‌دهنده',
  verifiers: 'تأییدکنندگان',
  followers: 'دنبال‌کنندگان',
  taskPublisher: 'ابلاغ کننده',
  subTaskPublisher: 'ابلاغ کننده گام‌ها',
  dateCombo: 'بازه',
};

const getDefaultDateTitle: { [key in defaultDates]: string } = {
  dueDate: 'تاریخ انجام',
  startDate: 'تاریخ شروع',
  dateCombo: 'بازه',
};

const addPeriod = (text: string) => {
  return `${text}: `;
};

export const addDash = (text: string) => {
  return `${text} - `;
};

export default {
  tableIndex: 'ردیف',
  fieldIsEmpty: '-',
  userNotExist: 'کاربر وجود ندارد',
  projectNameTitle: 'عنوان',
  withoutSubTasks: '- موردی برای نمایش وجود ندارد - ',
  from: 'از ',
  until: ' تا ',
  continues: ' به صورت مستمر',
  progressPerson: 'مسئول پایش',
  progressDate: 'تاریخ پایش ( توضیحات )',
  progress: 'درصد پیشرفت',
  noDescription: ' - ',
  percent: '٪',
  weight: 'وزن',

  getFieldsTitle(fieldName: string, withPeriod: boolean) {
    return withPeriod ? addPeriod(fieldName) : fieldName;
  },
  getAssignmentTitle(
    whichTitle: defaultTitles,
    withPeriod: boolean,
    customTitle?: string
  ) {
    const title = customTitle
      ? customTitle
      : getDefaultAssignmentTitle[whichTitle];
    return withPeriod ? addPeriod(title) : title;
  },
  getAssignmentName(name: string, withDash: boolean) {
    return withDash ? addDash(name) : name;
  },
  getDateTitle(
    whichDate: defaultDates,
    withPeriod: boolean,
    customTitle?: string
  ) {
    const title = customTitle ? customTitle : getDefaultDateTitle[whichDate];
    return withPeriod ? addPeriod(title) : title;
  },
  getSubTasksTitle(customTitle?: string) {
    return customTitle ? customTitle : 'گام‌ها';
  },
  getProviderItemTitle(withPeriod: boolean, customTitle?: string) {
    const title = customTitle ? customTitle : 'سند مرتبط';
    return withPeriod ? addPeriod(title) : title;
  },
  getMainProgressTitle(customTitle?: string) {
    return customTitle ? customTitle : 'درصد پیشرفت';
  },
  getMainProgressValue(progress: string) {
    return `${progress} درصد`;
  },
};
